import { withGridLayout } from "../../hocs/withGridLayout";
import { withModuleFetcher } from "../../hocs/withModuleFetcher";
import { withState } from "../../hocs/withState";
import { ComponentGridDecorated } from "./ComponentGridDecorated";

export const ComponentGrid = withModuleFetcher(withState(withGridLayout(ComponentGridDecorated)));
